<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>ERP 시스템</h1>
    </div>
    <div class="product">
      <div>
        <h1>MGN ERP 시스템 소개</h1>
        <p>ERP (Enterprise Resource Planning) 전사적 자원 관리</p>
        로 생산, 제조, 영업, 판매, 구매, 발주, 재고, 유통, 물류, 재무, 회계, 인사 등 전반적인 기업 활동을 통합적으로 관리함으로써 경영 자원의 활동을 최적화 합니다.
        <img src="../../image/page/1001.jpg" />
        <br />MGN ERP 시스템을 기반으로 기업의 업무 용도에 적합한 시스템으로 개발됩니다. <br />

        <div>
          <h1>업종 특화 보유 ERP 시스템 종류</h1>
          <ul>
            <li v-for="(i, key) in menu[0].sub" :key="key">
              <a :href="i.link" class="proMenu"> {{ key + 1 }} &#41; {{ i.name }} </a>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h1>ERP 시스템 기본 기능</h1>
        <FormTable :info="info"></FormTable>
        <br />
        <!-- &nbsp; -->
        <!-- <p><span style="color: red">*</span> 전자세금 계산서는 바로빌 전자세금 계산서을 사용하고 있습니다.</p> -->
      </div>
      <div>
        <h1>제품 구매 절차</h1>
        <p>상담 &nbsp;→ &nbsp;견적 &nbsp; → &nbsp;제품 구매/개발 &nbsp;→ &nbsp;테스트 &nbsp; → &nbsp;유지보수</p>
      </div>
    </div>
  </div>
</template>

<script>
import FormTable from '../static/FormTable.vue'
export default {
  components: { FormTable },
  data() {
    return {
      info: [
        {
          subject: '기초관리',
          element: '거래처 등록, 품목 등록, 단가 관리',
        },
        {
          subject: '판매관리',
          element: '수주 등록, 수주 현황, 생산 진행 현황, 제품 정보 조회, 재고 현황, 판매 계획 등록, 거래 명세서, 매출 현황, 공급 단가 분석표',
        },
        {
          subject: '구매관리',
          element: '발주 등록, 입고 등록, 발주 입고 현황',
        },
        {
          subject: '생산관리',
          element: '생산 계획 수립, 생산 실적 등록, 작업 대기 현황, 생산 대기 현황, 생산 현황',
        },
        {
          subject: '재고관리',
          element: '재고 현황, 수불 현황, 관리 대장',
        },
        {
          subject: '영업관리',
          element: '매출 입금 등록, 현황, 수주 현황, 매출 현황, 매출 거래처 원장, 외상 매출금 현황, 영업기획, 매출단가 검토표',
        },
        {
          subject: '마감관리',
          element: '매입 마감 확정, 매입 마감 현황, 매출 마감 확정, 전자 세금계산서 발행, 매출 세금 계산서 등록, 비용 현황',
        },
        {
          subject: '기타',
          element: '공지사항, SMS 관리',
        },
        {
          subject: '전자세금 계산서',
          element: '바로빌 전자계산서',
        },
      ],
    }
  },
  props: {
    menu: Array,
  },
  created() {},
}
</script>

<style scoped>
@import '../../style/content.css';
.product div img {
  margin: 0 200px;
}
@media (max-width: 960px) {
  .product div img {
    margin: 0 130px;
  }
}
.proMenu:hover {
  color: rgb(144, 177, 202);
}
</style>
